<p-dialog [draggable]="false" [resizable]="false" [(visible)]="visible"
    [style]="{ width: '330px', height: '61%' }" (onHide)="closeChangePassword()">
    <div class="text-center fm-prompt">
        <div class=" fw-bold text-black fs-4 ">
            Set New Password
        </div>
        <div class="fm-rubik" style="font-size: 0.9rem;font-weight: bold;">
            Set your new password to continue
        </div>
        <div class="mt-1 p-2 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.8rem;color: #848790;font-weight: 500;">Password</span>
            <br>
            <p-password [(ngModel)]="new_password" [toggleMask]="true"></p-password>
        </div>
        <div class="mt-1 p-2 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.8rem;color: #848790;font-weight: 500;">Confirm password</span>
            <p-password [(ngModel)]="new_password_confirmation" [toggleMask]="true"></p-password>
        </div>
        <div class="mt-1 p-2" style="text-align: center;">
            <button [disabled]="!new_password || !new_password_confirmation"
                [style.background-color]="new_password && new_password_confirmation ?  '#EF870A' : '#b4b4bb'"
                class="btn w-100 fm-prompt fw-bold"
                style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                (click)="changePassword()">Change password</button>
        </div>
    </div>
</p-dialog>
